import moment from 'moment'
import { prepareSort } from 'helpers/participantsTableSort'
import { coursesFastActionsFilterOptions } from 'enum/coursesFastActionsOptions.enum'
import api from '../..'

const hasCompareValue = (compareTo: unknown) =>
  compareTo != null && String(compareTo).trim() !== ''

const coursesList = (
  page: number,
  searchText = '',
  sort: any,
  usersFilter: any,
  perPage: number,
  fastFilters: number
) => {
  const q = { s: '', m: 'and' } as any
  q['s'] = prepareSort(
    {
      ...sort,
      ...{ field: sort.field === 'search_name' ? 'name' : sort.field },
    },
    'courses'
  )
  const trimmedSearch = searchText?.trim() ?? ''
  if (trimmedSearch) {
    q['search_name_or_lms_profiles_name_cont'] = trimmedSearch
  }
  if (fastFilters) {
    const { draftCourses, publishedCourses } = coursesFastActionsFilterOptions
    switch (fastFilters) {
      case publishedCourses:
        q['state_eq'] = 1
        break
      case draftCourses:
        q['state_eq'] = 0
        break
      default:
        break
    }
  }

  const hasSimpleFilters =
    usersFilter?.filterType === 'simple' &&
    Array.isArray(usersFilter.data) &&
    usersFilter.data.some(({ compareTo }: any) => hasCompareValue(compareTo))

  const hasGroupedFilters =
    usersFilter?.filterType != null &&
    usersFilter.filterType !== 'simple' &&
    Array.isArray(usersFilter.groupedData) &&
    usersFilter.groupedData.length > 0

  if (hasSimpleFilters || hasGroupedFilters) {
    q['g'] = [{}]
  }

  if (hasSimpleFilters) {
    q['g'][0]['m'] = usersFilter.generalCondition || 'and'
    const toDelete = [] as string[]
    usersFilter.data.map(({ input, operator, compareTo }: any) => {
      if (!hasCompareValue(compareTo)) return
      const inputIsDate = /(_at|_date)$/.test(input)
      if (inputIsDate) {
        input = input == 'created_at' ? `${input}_formatted` : input
        const dateNeedsToFormat = ['gteq', 'lteq', 'eq_days'].includes(operator)
        if (dateNeedsToFormat) {
          operator = operator == 'eq_days' ? 'eq' : operator
          const currentDate = new Date()
          currentDate.setDate(currentDate.getDate() - parseInt(compareTo))
          compareTo = moment(currentDate).format('YYYY-MM-DD')
        }
        compareTo = moment(compareTo).format('YYYY-MM-DD')
      }
      if (q['g'][0][`${input}_${operator}`] && !operator.includes('null')) {
        const op =
          usersFilter.generalCondition === 'and'
            ? `${operator}_all`
            : `${operator}_any`
        toDelete.push(`${input}_${operator}`)
        if (Array.isArray(q['g'][0][`${input}_${op}`])) {
          q['g'][0][`${input}_${op}`].push(compareTo)
        } else {
          q['g'][0][`${input}_${op}`] = [
            q['g'][0][`${input}_${operator}`],
            compareTo,
          ]
        }
      } else {
        q['g'][0][`${input}_${operator}`] = compareTo
      }
    })
    if (toDelete.length)
      toDelete.map((row: string) => {
        delete q['g'][0][row]
      })
  } else if (hasGroupedFilters) {
    q['g'][0]['g'] = []
    usersFilter.groupedData.map(({ data, groupCondition, group }: any) => {
      q['g'][0]['m'] = usersFilter.generalCondition
      q['g'][0]['g'].push({ m: '' })
      q['g'][0]['g'][group]['m'] = groupCondition
      const toDelete = [] as string[]
      data.map(({ input, operator, compareTo }: any) => {
        if (!hasCompareValue(compareTo)) return
        if (q['g'][0]['g'][group][`${input}_${operator}`]) {
          const op =
            groupCondition === 'and' ? `${operator}_all` : `${operator}_any`
          toDelete.push(`${input}_${operator}`)
          if (Array.isArray(q['g'][0]['g'][group][`${input}_${op}`])) {
            q['g'][0]['g'][group][`${input}_${op}`].push(compareTo)
          } else {
            q['g'][0]['g'][group][`${input}_${op}`] = [
              q['g'][0]['g'][group][`${input}_${operator}`],
              compareTo,
            ]
          }
        } else {
          q['g'][0]['g'][group][`${input}_${operator}`] = compareTo
        }
      })
      if (toDelete.length)
        toDelete.map((row: string) => {
          delete q['g'][0]['g'][group][row]
        })
    })
  }
  return api
    .post(`administration/courses/search`, { page, perPage, q })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default coursesList
